import React from "react";
import { formatCurrentVehicleDetailValue } from "./bookingVehicleSummaryUtils";

/** Vehicle lines under "Your selection" (wizard hub / model / plan steps). */
export interface YourSelectionVehicleDetailStrings {
  vehicleName: string;
  vehicleNum: string;
  registrationNumber: string;
  speed: string;
  range: string;
}

interface YourSelectionVehicleDetailRowsProps {
  selectionSummaryRow: (label: string, value: string) => React.ReactNode;
  details: YourSelectionVehicleDetailStrings;
}

/** Renders Vehicle name, Vehicle No., Registration No., Speed, Range in the selection card. */
const YourSelectionVehicleDetailRows: React.FC<YourSelectionVehicleDetailRowsProps> = ({
  selectionSummaryRow,
  details: d,
}) => (
  <>
    {selectionSummaryRow("Vehicle name", formatCurrentVehicleDetailValue(d.vehicleName))}
    {selectionSummaryRow("Vehicle No.", formatCurrentVehicleDetailValue(d.vehicleNum))}
    {selectionSummaryRow("Registration No.", formatCurrentVehicleDetailValue(d.registrationNumber))}
    {selectionSummaryRow("Speed", formatCurrentVehicleDetailValue(d.speed))}
    {selectionSummaryRow("Range", formatCurrentVehicleDetailValue(d.range))}
  </>
);

export default YourSelectionVehicleDetailRows;
